import React, { useState } from 'react'

import useModal from '@/hooks/useModalV2'
import Loading from '@/shared/Loading'
import Modal from '@/shared/Modal'
import ImageUploadFormR2 from '@/shared/ImageUploadFormR2'
import useQuery from '@/hooks/useQuery'
import { useGlobalState } from '@/state'

const ProfileGeneralAvatar = () => {
  const [user, setUser] = useGlobalState('userContainerUser')
  const [currentUser, setCurrentUser] = useGlobalState('currentUser')
  const [url, setUrl] = useState(user.largeImageUrl)
  const [uploaded, setUploaded] = useState(false)
  const { openModal, closeModal, isOpen } = useModal()
  const { getRequest } = useQuery()

  const reloadPublicImageURL = () => {
    getRequest(`/api/v3/users/${user.id}/image`, {}, (err, jsonData) => {
      if (err) { return }
      setUrl(jsonData.url)
      setUser({ ...user, publicImageUrl: jsonData.url })
      setCurrentUser({ ...currentUser, avatarUrl: jsonData.url })
    })
  }

  return (
    <>
      {/* Square, and sized to sit beside three stacked fields. */}
      <button type='button' onClick={openModal} title='Change picture' className='relative mt-1 block h-44 w-44 overflow-hidden rounded-xl border-2 border-dashed border-gray-300 p-1 hover:opacity-75 focus:outline-none focus:ring-2 focus:ring-cccblue dark:border-gray-600'>
        <img className='h-full w-full rounded-lg object-cover' src={url} alt={user.displayName} />
        { uploaded && <span className='absolute inset-0 flex items-center justify-center bg-white/60 dark:bg-gray-900/60'><Loading noMessage noLoadingMessage /></span> }
      </button>
      <Modal title="Edit Image" full isOpen={isOpen} closeModal={closeModal} >
        <div className='flex justify-center'>
          <div className="mt-2">
            <ImageUploadFormR2
              kind='User'
              url={url}
              setUrl={setUrl}
              success={reloadPublicImageURL}
              didUpload={setUploaded}
            />
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ProfileGeneralAvatar
